export enum Gender {
  NA = 'NA',

  MALE = 'Male',

  FEMALE = 'Female',

  OTHER = 'Other',
}
